<template>
  <div>
    <setUserTable />
    <el-form ref="formOverall" :model="formOrigin">
      <el-form-item label="员工:" class="release-label width-name">
        <el-input
          v-model="formOrigin.name"
          class="release-input"
          placeholder="请输入员工姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="关键词:" class="release-label width-keyWord">
        <el-input
          v-model="formOrigin.keyWord"
          class="release-input"
          placeholder="请输入关键词"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="查询日期:" class="release-label width-time">
        <el-date-picker
          :unlink-panels="true"
          v-model="formOrigin.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          class="release-select-time"
          :clearable="true"
          :editable="false"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="onSubmit" :loading="bottonLoading" class="filter">
        筛选
      </el-button>

      <el-button @click="replacement">重置</el-button>
    </el-form>
    <div class="search_content">
      <div class="content_left">
        <div class="left_title">搜索结果</div>
        <div class="left_box" @scroll.passive="representativeScroll($event)">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            unique-opened
            @close="handleClose"
          >
            <el-submenu
              :index="'1-' + index1"
              v-for="(item1, index1) in contentLeftList"
              :key="index1"
            >
              <template slot="title">
                <span>{{ item1.name }}({{ item1.total }})</span>
              </template>
              <div class="left_box_s" ref="staff" @scroll.passive="staffScroll($event)">
                <el-submenu
                  :index="'2-' + index2"
                  v-for="(item2, index2) in item1.list"
                  :key="index2"
                >
                  <template slot="title">
                    <span>
                      <span :class="item2.type == 1 ? 'external_color' : ''">
                        {{ item2.name ? item2.name : '群聊' }}
                      </span>
                      <span>({{ item2.total }})</span>
                      <span v-if="item2.is_external == 1" class="external_icon">外部</span>
                    </span>
                  </template>
                  <div class="left_box_ss" ref="record" @scroll.passive="recordScroll($event)">
                    <el-menu-item
                      :index="'3-' + index3"
                      v-for="(item3, index3) in item2.list"
                      :key="index3"
                      @click="content_left_click(item3)"
                    >
                      <h3 class="search_name">
                        <span
                          v-html="
                            brightenKeyword(
                              item3.msg_type === 'text'
                                ? JSON.parse(item3.msg_detail).content
                                : state_list[item3.msg_type],
                              formOverall.keyWord,
                            )
                          "
                        ></span>
                      </h3>
                      <p class="search_time">{{ item3.msg_time }}</p>
                    </el-menu-item>
                    <p v-if="recordLoad" class="load_hint">加载中...</p>
                  </div>
                </el-submenu>
                <p v-if="staffLoad" class="load_hint">加载中...</p>
              </div>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content_right">
        <div class="right_title">会话记录</div>
        <div class="dialogue_list">
          <div class="dialogue_list_s" v-for="(item, index) in dialogue_list" :key="index">
            <h3>
              {{ item.from_name || item.from_nickname || item.to_name }}
              <span :class="item.from_type == 2 ? 'external_color' : ''" v-if="item.from_type == 2">
                @{{ item.from_nickname }}
              </span>
              <span v-if="item.from_type == 2" class="span_icon">外部</span>
              <i>{{ dateFormat(new Date(item.msgtime), 'YYYY-MM-dd HH:mm:SS') }}</i>
            </h3>
            <!-- 图片消息 -->
            <div
              class="msgtype_image"
              v-if="item.msgtype === 'image' || item.msgtype === 'emotion'"
            >
              <msgtypeImage :items="item" />
            </div>
            <!-- 文本消息 -->
            <div class="msgtype_text" v-if="item.msgtype === 'text'">
              <msgtypeText :items="item" />
            </div>
            <!-- 同意消息 -->
            <div class="msgtype_agree">
              <p v-if="item.msgtype === 'agree'">{{ state_list[item.msg_type] }}</p>
              <p v-if="item.msgtype === 'disagree'">{{ state_list[item.msg_type] }}</p>
            </div>
            <!-- 语音消息 -->
            <div class="msgtype_voice" v-if="item.msgtype === 'voice'">
              <msgtypeVoice :items="item" />
            </div>
            <!-- 视频消息 -->
            <div class="msgtype_video" v-if="item.msgtype === 'video'">
              <msgtypeVideo :items="item" />
            </div>
            <!-- 名片消息 -->
            <div
              class="msgtype_card"
              v-if="
                item.msgtype === 'card' ||
                item.msgtype === 'calendar' ||
                item.msgtype === 'todo' ||
                item.msgtype === 'vote' ||
                item.msgtype === 'collect' ||
                item.msgtype === 'docmsg' ||
                item.msgtype === 'file' ||
                item.msgtype === 'meeting'
              "
            >
              <msgtypeCard :items="item" />
            </div>
            <!-- 位置消息 -->
            <div class="msgtype_location" v-if="item.msgtype === 'location'">
              <msgtypeLocation :items="item" :index="index" />
            </div>
            <!-- 链接消息 -->
            <div class="msgtype_link" v-if="item.msgtype === 'link'">
              <msgtypeLink :items="item" />
            </div>
            <!-- 小程序消息 -->
            <div class="msgtype_weapp" v-if="item.msgtype === 'weapp'">
              <msgtypeWeapp :items="item" />
            </div>
            <!-- 聊天记录消息 -->
            <div class="msgtype_chatrecord" v-if="item.msgtype === 'chatrecord'">
              <msgtypeChatrecord :items="item" />
            </div>
            <!-- 图文消息 -->
            <div class="msgtype_news" v-if="item.msgtype === 'news'">
              <msgtypeNews :items="item" />
            </div>
            <!-- 混合消息 -->
            <div class="msgtype_mixed" v-if="item.msgtype === 'mixed'">
              <msgtypeMixed :items="item" />
            </div>
            <!-- 音频共享文档消息 -->
            <div
              class="msgtype_voip_doc_share"
              v-if="
                item.msgtype === 'voip_doc_share' ||
                item.msgtype === 'markdown' ||
                item.msgtype === 'external_redpacket' ||
                item.msgtype === 'meeting_voice_call' ||
                item.msgtype === 'redpacket'
              "
            >
              <p>{{ state_list[item.msg_type] }}</p>
            </div>
            <!-- 切换企业日志消息 -->
            <div class="msgtype_action_switch" v-if="item.msgtype === 'action_switch'">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="release-page" v-if="dialogue_list.length > 0">
      <el-pagination
        class="release-pagination"
        @current-change="handleCurrentChanges"
        :page-size="dialogue_size"
        :current-page="dialogue_index"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :page-sizes="g_pageSizesConfig"
        :total="dialogue_total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time';
import msgtypeVideo from '../components/sessionInformation/msgtypeVideo';
import msgtypeImage from '../components/sessionInformation/msgtypeImage';
import msgtypeCard from '../components/sessionInformation/msgtypeCard';
import msgtypeText from '../components/sessionInformation/msgtypeText';
import msgtypeLink from '../components/sessionInformation/msgtypeLink';
import msgtypeVoice from '../components/sessionInformation/msgtypeVoice';
import msgtypeMixed from '../components/sessionInformation/msgtypeMixed';
import msgtypeLocation from '../components/sessionInformation/msgtypeLocation';
import msgtypeChatrecord from '../components/sessionInformation/msgtypeChatrecord';
import msgtypeNews from '../components/sessionInformation/msgtypeNews';
import msgtypeWeapp from '../components/sessionInformation/msgtypeWeapp';
import setUserTable from '../components/setUserTable';
import {
  EyaoSaaSQueryChatStaffList,
  EyaoSaaSQueryHasChatStaffList,
  EyaoSaaSQueryChatList,
  EyaoSaasGetChatDetailList,
} from '@/api/enterpriseWeChatManagement';
import moment from 'moment';

export default {
  name: 'ConversationView',
  components: {
    msgtypeVideo,
    msgtypeImage,
    msgtypeCard,
    msgtypeText,
    msgtypeLink,
    msgtypeVoice,
    msgtypeMixed,
    msgtypeLocation,
    msgtypeChatrecord,
    msgtypeNews,
    msgtypeWeapp,
    setUserTable,
  },
  props: {},
  data() {
    return {
      formOverall: {
        name: '', // 查询员工姓名
        time: [], // 查询时间
        keyWord: '', // 关键词
      }, // 用来查询的主体，会在搜索时从formOrigin中复制过来
      formOrigin: {
        name: '',
        time: [],
        keyWord: '',
      }, // 用来和表单绑定的主体
      bottonLoading: false,
      activeNames: ['1'],
      contentLeftList: [],
      total: 0, // 总页数
      currentPage: 1, // 页数
      size: 10, // 每页数量
      conversation_list: [],
      contentLeftList_index: null,
      contentLeftList_index_s: null,
      offsetA: 1,
      limitA: 10,
      totalA: 10,
      offsetB: [],
      limitB: [],
      totalB: [],
      staffLoad: true,
      offsetC: [],
      limitC: [],
      totalC: [],
      recordLoad: true,
      dialogue_list: [], // 会话记录列表
      dialogue_size: 10, // 会话记录每页显示条数
      dialogue_index: 1, // 会话记录当前页
      dialogue_total: 1, // 会话记录总条数
      dateFormat,
      from: '',
      to: '',
      roomid: '',
      state_list: {
        image: '[图片消息]',
        text: '[文本消息]',
        revoke: '[撤回消息]',
        agree: '[同意消息]',
        disagree: '[不同意消息]',
        voice: '[语音消息]',
        video: '[视频消息]',
        card: '[名片消息]',
        location: '[位置消息]',
        emotion: '[表情消息]',
        file: '[文件消息]',
        link: '[链接消息]',
        weapp: '[小程序消息]',
        chatrecord: '[聊天记录消息]',
        todo: '[待办消息]',
        vote: '[投票消息]',
        collect: '[填表消息]',
        redpacket: '[红包消息]',
        meeting: '[会议邀请消息]',
        docmsg: '[在线文档消息]',
        markdown: '[MarkDown格式消息]',
        newsnews: '[图文消息]',
        calendar: '[日程消息]',
        mixed: '[混合消息]',
        meeting_voice_call: '[音频存档消息]',
        voip_doc_share: '[音频共享文档消息]',
        external_redpacket: '[互通红包消息]',
        action_switch: '[切换企业日志消息]',
      },
    };
  },
  computed: {},
  created() {
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '企业微信管理管理', menu_path: '', menu_params: {} },
      { menu_name: '会话留存', menu_path: 'chattingRecords', menu_params: {} },
      { menu_name: '会话检索', menu_params: { componentName: 'conversationView' } },
    ];
    this.g_breadcrumb(breadcrumb);
  },
  mounted() {
    this.dialogue_size = this.g_pageSizeDefault;
    // this.EyaoSaaSQueryChatStaffList();
  },
  methods: {
    representativeScroll(event) {
      // 滚动条距离底部的距离scrollBottom
      const scrollBottom =
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      let { offsetA } = this;
      const pageMax = parseInt(this.totalA / this.limitA, 0);
      if (scrollBottom === 0) {
        offsetA += 1;
        if (offsetA > pageMax) {
          return false;
        }
        this.offsetA = offsetA;
        this.EyaoSaaSQueryChatStaffList();
      }
    },
    staffScroll(event) {
      // 滚动条距离底部的距离scrollBottom
      const scrollBottom =
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      const index = this.contentLeftList_index;
      let offsetB = this.offsetB[index];
      const pageMax = parseInt(this.totalB[index] / this.limitB[index], 0);
      console.log(scrollBottom);
      if (scrollBottom === 0) {
        offsetB += 1;
        if (offsetB > pageMax) {
          return false;
        }
        this.staffLoad = true;
        this.offsetB[index] = offsetB;
        this.EyaoSaaSQueryHasChatStaffList();
      }
    },
    recordScroll(event) {
      // 滚动条距离底部的距离scrollBottom
      const scrollBottom =
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      const index = this.contentLeftList_index_s;
      let offsetC = this.offsetC[index];
      const pageMax = parseInt(this.totalC[index] / this.limitC[index], 0);
      if (scrollBottom === 0) {
        offsetC += 1;
        if (offsetC > pageMax) {
          return false;
        }
        this.recordLoad = true;
        this.offsetC[index] = offsetC;
        this.EyaoSaaSQueryChatList();
      }
    },
    onSubmit() {
      this.bottonLoading = true;
      if (!this.formOrigin.keyWord) {
        this.$message({
          type: 'info',
          message: '请输入关键词',
        });
        this.bottonLoading = false;
        return false;
      }
      this.formOverall = JSON.parse(JSON.stringify(this.formOrigin));
      this.contentLeftList = [];
      this.dialogue_list = [];
      this.offsetA = 1;
      this.EyaoSaaSQueryChatStaffList();
    },
    replacement() {
      this.formOrigin = {
        name: '', // 查询员工姓名
        time: [], // 查询时间
        keyWord: '', // 关键词
      };
      this.contentLeftList = [];
      this.conversation_list = [];
      this.dialogue_list = [];
    },
    handleOpen(key) {
      const strBefore = key.split('-')[0];
      const strAfter = key.split('-')[1];
      console.log(strBefore);
      if (strBefore === '1') {
        this.contentLeftList_index = Number(strAfter);
        this.contentLeftList[this.contentLeftList_index].list.length = 0;
        this.offsetB[this.contentLeftList_index] = 1;
        this.EyaoSaaSQueryHasChatStaffList().then(() => {
          this.$nextTick(() => {
            this.$refs.staff[this.contentLeftList_index].scrollTop = 0;
          });
        });
      }
      if (strBefore === '2') {
        this.contentLeftList_index_s = Number(strAfter);
        this.contentLeftList[this.contentLeftList_index].list[
          this.contentLeftList_index_s
        ].list.length = 0;
        this.offsetC[this.contentLeftList_index_s] = 1;
        this.EyaoSaaSQueryChatList().then(() => {
          this.$nextTick(() => {
            this.$refs.record[this.contentLeftList_index_s].scrollTop = 0;
          });
        });
      }
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    brightenKeyword(val, keyword) {
      const Reg = new RegExp(keyword, 'i');
      if (val) {
        const res = val.replace(
          Reg,
          `<span style="color: #3aa1ff;vertical-align: top;">${keyword}</span>`,
        );
        return res;
      }
    },
    content_left_click(list3) {
      this.from = list3.from;
      this.to = list3.to;
      this.roomid = list3.room_id;
      this.EyaoSaasGetChatDetailList();
    },
    // 员工列表查询
    async EyaoSaaSQueryChatStaffList() {
      const timeList = this.targetdayMilliseconds();
      const req = Object.assign({
        staff_name: this.formOverall.name,
        keyword: this.formOverall.keyWord,
        begin_time: timeList[0],
        end_time: timeList[1],
        limit: this.limitA,
        offset: this.offsetA,
      });
      try {
        EyaoSaaSQueryChatStaffList(req)
          .then((res) => {
            console.log('员工列表查询', res);
            if (res) {
              this.bottonLoading = false;
              const staffList = res.staff_list;
              const { contentLeftList } = this;
              const offsetB = [];
              const limitB = [];
              const totalB = [];
              if (staffList) {
                staffList.forEach(function (val) {
                  const vals = val;
                  vals.list = [];
                  contentLeftList.push(val);
                  offsetB.push(1);
                  limitB.push(10);
                  totalB.push(val.total);
                });
                this.contentLeftList = contentLeftList;
                this.offsetB = offsetB;
                this.limitB = limitB;
                this.totalB = totalB;
              }
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (err) {
        this.bottonLoading = false;
      }
    },
    // 存在数据往来人员列表查询
    async EyaoSaaSQueryHasChatStaffList() {
      const { contentLeftList_index } = this;
      const timeList = this.targetdayMilliseconds();
      const req = Object.assign({
        staff_name: this.contentLeftList[contentLeftList_index].name,
        keyword: this.formOverall.keyWord,
        begin_time: timeList[0],
        end_time: timeList[1],
        limit: this.limitB[contentLeftList_index],
        offset: this.offsetB[contentLeftList_index],
      });
      try {
        EyaoSaaSQueryHasChatStaffList(req)
          .then((res) => {
            console.log('存在数据往来人员列表查询', res);
            if (res) {
              this.staffLoad = false;
              const staffList = res.staff_list;
              const contentLeftList = this.contentLeftList[contentLeftList_index].list;
              const offsetC = [];
              const limitC = [];
              const totalC = [];
              if (staffList) {
                staffList.forEach(function (val) {
                  const vals = val;
                  vals.list = [];
                  contentLeftList.push(vals);
                  offsetC.push(1);
                  limitC.push(10);
                  totalC.push(vals.total);
                });
                this.offsetC = offsetC;
                this.limitC = limitC;
                this.totalC = totalC;
                this.contentLeftList[contentLeftList_index].list = contentLeftList;
              }
            } else {
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (err) {}
    },
    targetdayMilliseconds() {
      const today = new Date();
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * 7;
      today.setTime(targetdayMilliseconds);
      let getHours = today.getHours();
      let getMinutes = today.getMinutes();
      let getSeconds = today.getSeconds();
      if (getHours < 10) {
        getHours = `0${getHours}`;
      }
      if (getMinutes < 10) {
        getMinutes = `0${getMinutes}`;
      }
      if (getSeconds < 10) {
        getSeconds = `0${getSeconds}`;
      }
      // const times = `${getHours}:${getMinutes}:${getSeconds}`;
      let startTime;
      let endTime;
      if (!this.formOverall.time) {
        startTime = '';
        endTime = '';
      } else if (this.formOverall.time.length === 0) {
        startTime = '';
        endTime = '';
      } else {
        // startTime = `${this.formOverall.time[0]} ${times}`;
        // endTime = `${this.formOverall.time[1]} ${times}`;
        startTime = moment(this.formOverall.time[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        endTime = moment(this.formOverall.time[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      const timeList = [startTime, endTime];
      return timeList;
    },
    // 聊天记录树查询
    async EyaoSaaSQueryChatList() {
      const { contentLeftList_index } = this;
      const { contentLeftList_index_s } = this;
      const timeList = this.targetdayMilliseconds();
      const req = Object.assign({
        staff_name: this.contentLeftList[contentLeftList_index].name,
        has_chat_name:
          this.contentLeftList[contentLeftList_index].list[contentLeftList_index_s].name,
        keyword: this.formOverall.keyWord,
        begin_time: timeList[0],
        end_time: timeList[1],
        limit: this.limitC[contentLeftList_index_s],
        offset: this.offsetC[contentLeftList_index_s],
        room_id: this.contentLeftList[contentLeftList_index].list[contentLeftList_index_s].room_id,
      });
      try {
        EyaoSaaSQueryChatList(req)
          .then((res) => {
            if (res) {
              console.log('聊天记录树查询', res);
              this.staffLoad = false;
              this.recordLoad = false;
              const staffList = res.info_list;
              const contentLeftList =
                this.contentLeftList[contentLeftList_index].list[contentLeftList_index_s].list;
              if (staffList.length > 0) {
                staffList.forEach(function (val) {
                  const vals = val;
                  vals.list = [];
                  contentLeftList.push(val);
                });
                this.contentLeftList[contentLeftList_index].list[contentLeftList_index_s].list =
                  contentLeftList;
              } else {
                this.staffLoad = false;
                this.recordLoad = false;
              }
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (err) {}
    },
    // 会话聊天记录选择页
    handleCurrentChanges(val) {
      this.dialogue_index = val;
      this.EyaoSaasGetChatDetailList();
    },
    handleSizeChange(val) {
      this.dialogue_index = 1;
      this.dialogue_size = val;
      this.EyaoSaasGetChatDetailList();
    },
    // 获取会话聊天记录
    async EyaoSaasGetChatDetailList() {
      const req = Object.assign({
        from: this.from,
        to: this.to,
        roomid: this.roomid,
        page_index: this.dialogue_index,
        page_size: this.dialogue_size,
      });
      EyaoSaasGetChatDetailList(req)
        .then((res) => {
          if (res) {
            const lists = [];
            for (let i = 0; i < res.list.length; i++) {
              if (res.list[i].msgtype !== 'action_switch') {
                try {
                  res.list[i].content = JSON.parse(res.list[i].content);
                } catch (err) {
                  res.list[i].content = res.list[i].content;
                }
              } else {
                res.list[i].content = res.list[i].content;
              }
              lists.push(res.list[i]);
            }
            console.log(lists);
            this.dialogue_list = lists;
            this.dialogue_total = res.total;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-submenu.is-active .el-submenu__title {
  box-shadow: inset 0 -1px 0 0 #ebebeb;
}
.el-menu .el-submenu .el-menu-item {
  height: 70px;
  line-height: 70px;
}

.external_color {
  color: #67c23a;
}
.external_icon {
  display: inline-block;
  width: 32px;
  height: 18px;
  font-size: 10px;
  line-height: 18px;
  color: #2f96ff;
  text-align: center;
  background: rgba(47, 150, 255, 0.08);
  border-radius: 2px;
}
.search_name {
  padding-top: 10px;
  overflow: hidden;
  font-size: 16px;
  line-height: 30px;
  color: #303133;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search_time {
  font-size: 12px;
  line-height: 20px;
  color: #909399;
}
.release-label {
  display: inline-block;
}
.width-time {
  width: 406px;
}
.width-keyWord {
  width: 260px;
  margin-left: 18px;
}
.width-name {
  width: 230px;
  margin-left: 18px;
}
.release-select-time {
  width: 320px;
  min-width: 240px;
  border-radius: 8px;
}
.release-input {
  width: unset;
  border-radius: 8px;
}
.search_content {
  display: flex;
  width: 100%;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  .content_left {
    width: 40%;
    .left_title {
      width: 100%;
      height: 48px;
      padding-left: 25px;
      font-size: 16px;
      line-height: 48px;
      color: #303133;
      text-align: left;
      background: #f5f7fa;
      border-radius: 8px 8px 0 0;
      box-sizing: border-box;
    }
    .left_box {
      max-height: calc(56px * 9);
      overflow: auto;
    }
  }
  .left_box_s {
    max-height: calc(56px * 9);
    overflow: auto;
    .left_box_ss {
      max-height: calc(70px * 2);
      overflow: auto;
    }
  }
  .content_right {
    width: 60%;
    .right_title {
      width: 100%;
      height: 48px;
      padding-left: 25px;
      font-size: 16px;
      line-height: 48px;
      color: #303133;
      text-align: left;
      background: #f5f7fa;
      border-radius: 8px 8px 0 0;
      box-sizing: border-box;
    }
  }
}
.release-page {
  height: 50px;
  margin-top: 20px;
  text-align: right;
}
.dialogue_list_pages {
  width: 100%;
  padding: 20px 10px;
  text-align: right;
  box-sizing: border-box;
}
.dialogue_list_s {
  width: 100%;
  margin: 30px 0;
  background: #fff;
  h3 {
    padding: 0 12px;
    overflow: hidden;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    color: #909399;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      display: inline-block;
      width: 32px;
      height: 18px;
      font-size: 10px;
      line-height: 18px;
      color: #2f96ff;
      text-align: center;
      background: rgba(47, 150, 255, 0.08);
      border-radius: 2px;
    }
    .external_color {
      width: auto;
      color: #67c23a;
      background: none;
    }
    i {
      font-size: 12px;
      color: #909399;
    }
  }
  .external_color {
    color: #67c23a;
  }
  p {
    padding: 0 12px;
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.load_hint {
  font-size: 14px;
  line-height: 30px;
  color: #999;
  text-align: center;
}
::v-deep {
  .el-date-editor .el-range-separator {
    width: auto;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 5px;
  }
  .release-select-time {
    height: auto;
    .el-range__close-icon {
      margin-right: 10px;
    }
  }
  .release-page .el-pagination__editor.el-input {
    width: 110px;
  }
  .release-page .el-input.el-input__inner {
    width: 100px;
  }
}
.msgtype_action_switch {
  padding: 0 12px;
  box-sizing: border-box;
  p {
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
